<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                温室效应的危害
            </div>
            <div class="content">
                <IndexVideo v-on:onIndexChanged="onIndexChanged" v-if="index == 1" />
                <TextView v-on:onIndexChanged="onIndexChanged" v-if="index == 2" />
            </div>

        </div>
    </div>
</template>

<script>
    import IndexVideo from "./IndexVideo";
    import TextView from "./TextView";
    export default {
        name: "WhatIsGreenhouseIndexView",
        components: {IndexVideo, TextView},
        data() {
            return {
                index: 1
            }
        },
        methods: {
            onIndexChanged(retIndex) {
                this.index = retIndex
            }
        }
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            .content {
                margin-top: 40px;
            }
            p {
                line-height: 12px;
            }

        }
    }
</style>